import { useEffect, useState } from "react";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import Process from "@/components/Process";
import Studio from "@/components/Studio";
import Footer, { ContactCTA } from "@/components/Footer";
import OrderDialog from "@/components/OrderDialog";

export default function Home() {
  const [services, setServices] = useState(null);
  const [orderOpen, setOrderOpen] = useState(false);
  const [orderService, setOrderService] = useState(null);

  useEffect(() => {
    import("@/lib/api").then(({ api }) =>
      api
        .get("/services")
        .then((r) => setServices(r.data))
        .catch(() => setServices([]))
    );
  }, []);

  const openOrder = (service = null) => {
    setOrderService(service);
    setOrderOpen(true);
  };

  return (
    <main className="min-h-screen bg-paper text-ink" data-testid="home-page">
      <Nav onOrder={() => openOrder()} />
      <Hero onOrder={() => openOrder()} />
      <Marquee />
      <Services services={services} onOrder={openOrder} />
      <Process />
      <Studio />
      <ContactCTA onOrder={() => openOrder()} />
      <Footer />
      <OrderDialog
        open={orderOpen}
        onOpenChange={setOrderOpen}
        services={services || []}
        initialService={orderService}
      />
    </main>
  );
}
